import { useContext, useEffect } from 'react';

import styles from './candidateInfo.module.scss';

import addPictureIcon from '../../../assets/icons/add_photo.svg';
import editIcon from '../../../assets/icons/orange_pencil.svg';

import envelopeIcon from '../../../assets/icons/envelope.svg';
import locationIcon from '../../../assets/icons/location.svg';
import phoneIcon from '../../../assets/icons/phone.svg';
import { getTalent, getTalentByEmail } from '../../api/talentClient';
import { AppContext } from '../../../router/approuter';
import { buildCurrencyFormat, unsearializaDateString } from '../../core/helper';
import { MONTHS, selectEmtpy } from '../../core/hardcode';
import { CandidateContext } from './context';
import { appConfig } from '../../config/runtimeConfig';

const CandidateResume = ({
  setStepIndex,
  setResumeViewFlag,
  personalInfo,
  setPersonalInfo,
  displayNotification,
  catCountries,
  catCurrencies,
}) => {
  const appContext = useContext(AppContext);
  const { setPersonalInfoCache } = useContext(CandidateContext);
  const courseTypes = {
    1001900001: 'Certificación',
    1001900006: 'Curso',
    1001900002: 'Diplomado',
  };

  const cookieDomain = appConfig.cookieDomain;
  const cookieName = appConfig.cookieName;

  const getUserInfo = (talentId) => {
    appContext.showLoading(true, 'Cargando', styles.no_scroll);
    getTalent(talentId, appContext.userData.token)
      .then(({ status, data }) => {
        const { result } = data;
        const countryFind =
          result.address &&
          result.address.country &&
          catCountries &&
          catCountries.length > 0 &&
          catCountries.find((c) => c.optionName === result.address.country);
        const currencyFind =
          catCurrencies.length > 0 && result.currency
            ? catCurrencies.find((c) => c.id === result.currency)
            : null;
        const currency = currencyFind
          ? currencyFind.description
          : 'Sin especificar';
        const currencyString =
          result.salaryMin && result.salaryMax
            ? `$${buildCurrencyFormat(
                result.salaryMin,
              )} - $${buildCurrencyFormat(result.salaryMax)} (${currency})`
            : null;
        const currentCurrencyFind =
          catCurrencies.length > 0 && result.currentSalaryCurrencyId
            ? catCurrencies.find((c) => c.id === result.currentSalaryCurrencyId)
            : null;
        const currentCurrency = currentCurrencyFind
          ? currentCurrencyFind.description
          : 'Sin especificar';
        const currentCurrencyString = result.currentSalary
          ? `$${buildCurrencyFormat(result.currentSalary)} (${currentCurrency})`
          : null;
        const personalInfo = {
          firstName: result.firstName,
          lastName: result.lastName,
          position: result.position,
          jobSeniority: result.jobSeniority,
          jobSeniorityId: result.jobSeniorityId,
          description: result.description,
          phone: result.phone,
          email: result.email,
          countryName: result.address?.country,
          country: countryFind
            ? { id: countryFind.id, description: countryFind.optionName }
            : selectEmtpy,
          state: result.address?.state,
          imgProfile: result.imgProfile,
          nss: result.nss ? `${result.nss}` : '',
          curp: result.curp,
          businessSectors: result.businessSectors,
          currency: currencyFind
            ? { id: currencyFind.id, description: currencyFind.optionName }
            : undefined,
          currentCurrency: currentCurrencyFind
            ? {
                id: currentCurrencyFind.id,
                description: currentCurrencyFind.optionName,
              }
            : undefined,
          currencyString,
          currentCurrencyString,
          salaryMin: result.salaryMin,
          salaryMax: result.salaryMax,
          currentSalary: result.currentSalary,
          previousJobs: result.previousJobs,
          educations: result.educations,
          courses: result.courses,
          languages: result.languages,
          skills: result.skills,
        };
        setPersonalInfo(personalInfo);
        setPersonalInfoCache(personalInfo);
        const currentDate = new Date();
        currentDate.setFullYear(currentDate.getFullYear() + 1);
        const sessionCookie = `${cookieName}=${appContext.userData.userProfile.firstName}|${appContext.userData.userProfile.lastName}|${appContext.userData.userProfile.id}|${appContext.userData.userProfile.talentId}|${appContext.userData.token};expires=${currentDate};domain=${cookieDomain};path=/;`;
        // console.log('CandidateResume - Cookie session', sessionCookie);
        document.cookie = sessionCookie;
        appContext.showLoading(false, '', styles.no_scroll);
      })
      .catch((error) => {
        console.log(error);
        if (error.code === 'ERR_NETWORK') {
          displayNotification(null, false, false, true);
        }
        appContext.showLoading(false, '', styles.no_scroll);
      });
  };

  const fetchTalentByEmail = () => {
    appContext.showLoading(true, 'Cargando', styles.no_scroll);
    getTalentByEmail(
      appContext.userData.userProfile.email,
      appContext.userData.token,
    )
      .then(({ status, data }) => {
        if (status === 200 && data.code === 200) {
          const talentId = data.result.id;
          const userInfo = {
            ...appContext.userData,
            userProfile: {
              ...appContext.userData.userProfile,
              talentId,
            },
          };
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          appContext.setUserData(userInfo);
          getUserInfo(talentId);
        } else {
          appContext.showLoading(false, '', styles.no_scroll);
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.code === 'ERR_NETWORK') {
          displayNotification(null, false, false, true);
        }
        appContext.showLoading(false, '', styles.no_scroll);
      });
  };

  useEffect(() => {
    setResumeViewFlag(true);
    localStorage.removeItem('userNew');
    if (appContext.userData.userProfile.talentId && catCurrencies.length > 0) {
      getUserInfo(appContext.userData.userProfile.talentId);
    } else if (
      catCurrencies.length > 0 &&
      !appContext.userData.userProfile.talentId
    ) {
      fetchTalentByEmail();
    }
  }, [appContext.userData, catCurrencies]);

  const updateView = (index) => {
    window.scrollTo(0, 0);
    setStepIndex(index);
  };

  const getParsedDate = (dateString) => {
    // const date = new Date(dateString);
    // return `${date.toLocaleString('es-ES', { month: 'long' }).charAt(0).toUpperCase()}${date.toLocaleString('es-ES', { month: 'long' }).slice(1)} ${date.getFullYear()}`
    const dateJson = unsearializaDateString(dateString);
    const fMes = MONTHS.find((m) => m.id === dateJson.monthId);
    return `${fMes.optionName} ${dateJson.yearDesc}`;
  };

  return (
    <div className={styles.candidate_resume}>
      <p className={styles.title}>Mi perfil</p>
      <hr className={styles.mobile_separator} />
      <div className={styles.personal_info}>
        <div className={styles.section_header}>
          <div className={styles.section_title}>
            <div className={styles.decorator}></div>
            Informaci&oacute;n Personal
          </div>
          <div className={styles.button_container}>
            <div className={styles.vertical_separator}></div>
            <button className={styles.add_info} onClick={() => updateView(0)}>
              Editar
              <img src={editIcon} alt="" />
            </button>
          </div>
        </div>
        {Object.keys(personalInfo).length > 0 ? (
          <div className={styles.personal_info_wrapper}>
            <div className={styles.profile_info}>
              <div className={styles.picture_column}>
                {personalInfo.imgProfile ? (
                  <div className={styles.candidate_profile_picture}>
                    <img
                      src={`${personalInfo.imgProfile}?${performance.now()}`}
                      alt=""
                    />
                  </div>
                ) : (
                  <button onClick={() => updateView(0)}>
                    <img src={addPictureIcon} alt="" />
                  </button>
                )}
              </div>
              <div className={styles.candidate_info_columns}>
                <p className={`${styles.candidate} ${styles.candidate_name}`}>
                  {personalInfo.firstName} {personalInfo.lastName}
                </p>
                <p
                  className={`${styles.candidate} ${styles.candidate_position}`}
                >
                  {personalInfo.position} {personalInfo.jobSeniority || ''}
                </p>
                <div className={styles.candidate_contact_info}>
                  <div className={styles.contact_field}>
                    <img src={envelopeIcon} alt="" />
                    <p>{personalInfo.email}</p>
                  </div>
                  <div className={styles.personal_info_separator}></div>
                  <div className={styles.contact_field}>
                    <img src={phoneIcon} alt="" />
                    <p>{personalInfo.phone || 'No proporcionado'}</p>
                  </div>
                  <div className={styles.personal_info_separator}></div>
                  <div className={styles.contact_field}>
                    <img src={locationIcon} alt="" />
                    {personalInfo.countryName && personalInfo.state ? (
                      <p>
                        {personalInfo.countryName + ', ' + personalInfo.state}
                      </p>
                    ) : (
                      <p>No proporcionado</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.candidate_contact_info_mobile}>
              <div className={styles.contact_field}>
                <img src={envelopeIcon} alt="" />
                <p>{personalInfo.email}</p>
              </div>
              <div className={styles.personal_info_separator}></div>
              <div className={styles.contact_field}>
                <img src={phoneIcon} alt="" />
                <p>{personalInfo.phone || 'No proporcionado'}</p>
              </div>
              <div className={styles.personal_info_separator}></div>
              <div className={styles.contact_field}>
                <img src={locationIcon} alt="" />
                {personalInfo.countryName && personalInfo.state ? (
                  <p>{personalInfo.countryName + ', ' + personalInfo.state}</p>
                ) : (
                  <p>No proporcionado</p>
                )}
              </div>
            </div>
            <div className={styles.about_candidate}>
              <label htmlFor="">Acerca de ti</label>
              <p className={styles.content}>
                {personalInfo.description || 'No proporcionado'}
              </p>
              <div className={`${styles.section} ${styles.section_short}`}>
                <div className={styles.section_subtitle}>
                  <label>N&uacute;mero de seguro social: </label>
                  {personalInfo.nss || 'No proporcionado'}
                </div>
                <div className={styles.section_subtitle}>
                  <label>CURP: </label>
                  {personalInfo.curp || 'No proporcionado'}
                </div>
                <div className={styles.section_subtitle}>
                  <label>Experiencia en sector: </label>
                  {personalInfo.businessSectors || 'No proporcionado'}
                </div>
                <div className={styles.section_subtitle}>
                  <label>Sueldo neto actual o &uacute;ltimo: </label>
                  {personalInfo.currentCurrencyString || 'No proporcionado'}
                </div>
                <div className={styles.section_subtitle}>
                  <label>Expectativa salarial neta: </label>
                  {personalInfo.currencyString || 'No proporcionado'}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p style={{ margin: '24px 0' }}>
            Agrega informaci&oacute;n personal y de contacto.
          </p>
        )}
        <hr className={styles.separator} />
        <div className={styles.section}>
          <div className={styles.section_header}>
            <div className={styles.section_title}>
              <div className={styles.decorator}></div>
              Experiencia Profesional
            </div>
            <div className={styles.button_container}>
              <div className={styles.vertical_separator}></div>
              <button className={styles.add_info} onClick={() => updateView(1)}>
                Editar
                <img src={editIcon} alt="" />
              </button>
            </div>
          </div>
          <div className={styles.cards_wrapper}>
            {personalInfo.previousJobs &&
            personalInfo.previousJobs.length > 0 ? (
              personalInfo.previousJobs?.map((jobInfo, index) => {
                return (
                  <div key={index} className={styles.info_card}>
                    <div className={styles.card_title}>
                      <label>{jobInfo.position}</label>
                      <label className={styles.hidden_mobile}>-</label>
                      <label>{jobInfo.employer || 'No proporcionado'}</label>
                      <label className={styles.hidden_mobile}>-</label>
                      <label>
                        Sector: {jobInfo.sectorName || 'No proporcionado'}
                      </label>
                    </div>
                    <p className={styles.info_date}>{`${
                      jobInfo.startDate
                        ? getParsedDate(jobInfo.startDate)
                        : 'No proporcionado'
                    } - ${
                      jobInfo.endDate
                        ? getParsedDate(jobInfo.endDate)
                        : 'Actualidad'
                    }`}</p>
                    <p className={styles.info_description}>
                      {jobInfo.description ||
                        'No describiste actividades realizadas en este puesto'}
                    </p>
                  </div>
                );
              })
            ) : (
              <p style={{ marginTop: '24px' }}>
                Agrega informaci&oacute;n sobre tu experiencia profesional
                (puedes incluir pr&aacute;cticas profesionales).
              </p>
            )}
          </div>
        </div>
        <hr className={styles.separator} />
        <div className={styles.section}>
          <div className={styles.section_header}>
            <div className={styles.section_title}>
              <div className={styles.decorator}></div>
              Formaci&oacute;n Acad&eacute;mica
            </div>
            <div className={styles.button_container}>
              <div className={styles.vertical_separator}></div>
              <button className={styles.add_info} onClick={() => updateView(2)}>
                Editar
                <img src={editIcon} alt="" />
              </button>
            </div>
          </div>
          <div className={styles.cards_wrapper}>
            {personalInfo.educations && personalInfo.educations.length > 0 ? (
              personalInfo.educations?.map((educationInfo, index) => {
                return (
                  <div key={index} className={styles.info_card}>
                    <div className={styles.card_title}>
                      <label>{educationInfo.name}</label>
                      <label className={styles.hidden_mobile}>-</label>
                      <label>
                        {educationInfo.school || 'No proporcionado'}
                      </label>
                    </div>
                    <p className={styles.info_date}>{`${
                      educationInfo.startDate
                        ? getParsedDate(educationInfo.startDate)
                        : 'No proporcionado'
                    } - ${
                      educationInfo.endDate
                        ? getParsedDate(educationInfo.endDate)
                        : 'En curso'
                    }`}</p>
                  </div>
                );
              })
            ) : (
              <p style={{ marginTop: '24px' }}>
                Agrega informaci&oacute;n acerca de tu formaci&oacute;n
                acad&eacute;mica.
              </p>
            )}
          </div>
        </div>
        <hr className={styles.separator} />
        <div className={styles.section}>
          <div className={styles.section_header}>
            <div className={styles.section_title}>
              <div className={styles.decorator}></div>
              Certificaciones y Cursos
            </div>
            <div className={styles.button_container}>
              <div className={styles.vertical_separator}></div>
              <button className={styles.add_info} onClick={() => updateView(3)}>
                Editar
                <img src={editIcon} alt="" />
              </button>
            </div>
          </div>
          <div className={styles.cards_wrapper}>
            {personalInfo.courses && personalInfo.courses.length > 0 ? (
              personalInfo.courses?.map((courseInfo, index) => {
                const periodStart = courseInfo.startDate
                  ? getParsedDate(courseInfo.startDate)
                  : 'Sin especificar';
                const periodEnd = courseInfo.endDate
                  ? getParsedDate(courseInfo.endDate)
                  : 'En curso';
                const labelPeriod =
                  courseInfo.startDate && courseInfo.endDate
                    ? 'Periodo'
                    : !courseInfo.startDate && courseInfo.endDate
                    ? 'Fecha de término'
                    : 'Periodo';
                const period =
                  (courseInfo.startDate && courseInfo.endDate) ||
                  (courseInfo.startDate && !courseInfo.endDate)
                    ? `${periodStart} - ${periodEnd}`
                    : periodEnd;
                return (
                  <div key={index} className={styles.info_card}>
                    <div className={styles.card_title}>
                      <label>{courseTypes[courseInfo.typeId]}</label>
                      <label className={styles.hidden_mobile}>-</label>
                      <label>{courseInfo.name}</label>
                      <label className={styles.hidden_mobile}>-</label>
                      <label>{courseInfo.school}</label>
                    </div>
                    <div>
                      <p className={styles.info_description}>
                        Número de certificado:{' '}
                        {courseInfo.certificateNumber ||
                          'Sin número de certificado'}
                      </p>
                      <p
                        className={styles.info_date}
                      >{`${labelPeriod}: ${period}`}</p>
                      <p className={styles.info_date}>
                        Fecha de vigencia:{' '}
                        {`${
                          courseInfo.validityDate
                            ? getParsedDate(courseInfo.validityDate)
                            : 'Sin vigencia'
                        }`}
                      </p>
                    </div>
                  </div>
                );
              })
            ) : (
              <p style={{ marginTop: '24px' }}>
                Agrega informaci&oacute;n de los cursos o certificaciones que
                has tomado recientemente.
              </p>
            )}
          </div>
        </div>
        <hr className={styles.separator} />
        <div className={styles.section}>
          <div className={styles.section_header}>
            <div className={styles.section_title}>
              <div className={styles.decorator}></div>
              Idiomas
            </div>
            <div className={styles.button_container}>
              <div className={styles.vertical_separator}></div>
              <button className={styles.add_info} onClick={() => updateView(4)}>
                Editar
                <img src={editIcon} alt="" />
              </button>
            </div>
          </div>
          <div className={styles.cards_wrapper}>
            {personalInfo.languages && personalInfo.languages.length > 0 ? (
              personalInfo.languages?.map((languageInfo, index) => {
                return (
                  <div key={index} className={styles.info_card}>
                    <div className={styles.language_info}>
                      <label>
                        {`${languageInfo.languageName} ${
                          languageInfo.langLevelName
                        } - ${
                          languageInfo.langLevelDescription?.split(':')[0]
                        }: `}{' '}
                      </label>
                      <p>{languageInfo.langLevelDescription?.split(':')[1]}</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <p style={{ marginTop: '24px' }}>
                Agrega los idiomas que domines actualmente, adicional al
                Espa&ntilde;ol.
              </p>
            )}
          </div>
        </div>
        <hr className={styles.separator} />
        <div className={styles.section}>
          <div className={styles.section_header}>
            <div className={styles.section_title}>
              <div className={styles.decorator}></div>
              Habilidades
            </div>
            <div className={styles.button_container}>
              <div className={styles.vertical_separator}></div>
              <button className={styles.add_info} onClick={() => updateView(5)}>
                Editar
                <img src={editIcon} alt="" />
              </button>
            </div>
          </div>
          {personalInfo.skills &&
            personalInfo.skills.filter((s) => s.categoryId === 1001100001)
              .length > 0 && (
              <p className={styles.section_title_thin}>Competencias técnicas</p>
            )}
          {personalInfo.skills &&
            personalInfo.skills.filter((s) => s.categoryId === 1001100001)
              .length > 0 && (
              <div className={styles.pills_wrapper}>
                {personalInfo.skills
                  ?.filter((s) => s.categoryId === 1001100001)
                  .map((skillInfo, index) => (
                    <p
                      key={index}
                    >{`${skillInfo.name} (${skillInfo.skillLevelPercentage}%)`}</p>
                  ))}
              </div>
            )}
          {personalInfo.skills &&
            personalInfo.skills.filter((s) => s.categoryId === 1001100002)
              .length > 0 && (
              <p className={styles.section_title_thin}>
                Competencias personales
              </p>
            )}
          {personalInfo.skills &&
            personalInfo.skills.filter((s) => s.categoryId === 1001100002)
              .length > 0 && (
              <div className={styles.pills_wrapper}>
                {personalInfo.skills
                  ?.filter((s) => s.categoryId === 1001100002)
                  .map((skillInfo, index) => (
                    <p
                      key={index}
                    >{`${skillInfo.name} (${skillInfo.skillLevelPercentage}%)`}</p>
                  ))}
              </div>
            )}
          {(!personalInfo.skills ||
            personalInfo.skills.filter(
              (s) => s.categoryId === 1001100001 || s.categoryId === 1001100002,
            ).length === 0) && (
            <p style={{ marginTop: '24px' }}>
              Agrega tus competencias t&eacute;cnicas y personales.
            </p>
          )}
        </div>
        <hr className={styles.separator} />
        <div className={styles.section}>
          <div className={styles.section_header}>
            <div className={styles.section_title}>
              <div className={styles.decorator}></div>
              Software
            </div>
            <div className={styles.button_container}>
              <div className={styles.vertical_separator}></div>
              <button className={styles.add_info} onClick={() => updateView(6)}>
                Editar
                <img src={editIcon} alt="" />
              </button>
            </div>
          </div>
          {personalInfo.skills &&
            personalInfo.skills.filter((s) => s.categoryId === 1001100004)
              .length > 0 && (
              <div className={styles.pills_wrapper}>
                {personalInfo.skills
                  ?.filter((s) => s.categoryId === 1001100004)
                  .map((skillInfo, index) => (
                    <p
                      key={index}
                    >{`${skillInfo.name} (${skillInfo.skillLevelPercentage}%)`}</p>
                  ))}
              </div>
            )}
          {(!personalInfo.skills ||
            personalInfo.skills.filter((s) => s.categoryId === 1001100004)
              .length === 0) && (
            <p style={{ marginTop: '24px' }}>
              Agrega los software que sepas utilizar.
            </p>
          )}
        </div>
        <hr className={styles.separator} />
        <div className={styles.buttons}>
          <button onClick={() => updateView(9)}>Terminar Perfil</button>
        </div>
      </div>
    </div>
  );
};
export default CandidateResume;
